import { Injectable } from "@angular/core";
import { ICardInfoData, CARD_INFO_ENUM, ICardWithBulletsData } from "../interfaces/card-info.interface";
import { AIDevelopmentCardInfo, AIDevelopmentNumberedCardInfo } from "../data/ai-development-info";
import { AppMarketingInfo, AppMarketingInfoWithBackground } from "../data/app-marketing-info";
import { HealthcareMarketingInfo, HealthcareMarketingNumberedCardInfo } from "../data/healthcare-marketing-info";
import { BusinessMobileConsulting, BusinessMobileConsultingNumberedCardInfo } from "../data/business-mobile-consulting";
import { AEO_BULLETS } from "../data/aeo-info";


@Injectable({
    providedIn: 'root'
})
export class CardInfoService {

    getCardInfoData(type: CARD_INFO_ENUM): ICardInfoData[] {
        switch (type) {
            case CARD_INFO_ENUM.AI_DEV_INFO:
                return AIDevelopmentCardInfo;
            case CARD_INFO_ENUM.APP_MARKETING:
                return AppMarketingInfo
            case CARD_INFO_ENUM.HEALTHCARE_MARKETING:
                return HealthcareMarketingInfo
            case CARD_INFO_ENUM.BUSINESS_MOBILE_CONSULTING:
                return BusinessMobileConsulting
            default:
                return []
        }
    }

    getNumberedCardInfo(type: CARD_INFO_ENUM): ICardInfoData[] {
        switch (type) {
            case CARD_INFO_ENUM.AI_DEV_INFO:
                return AIDevelopmentNumberedCardInfo;
            case CARD_INFO_ENUM.HEALTHCARE_MARKETING:
                return HealthcareMarketingNumberedCardInfo;
            case CARD_INFO_ENUM.BUSINESS_MOBILE_CONSULTING:
                return BusinessMobileConsultingNumberedCardInfo;
            default:
                return []
        }
    }

    getCardWithBackgroundData(type: CARD_INFO_ENUM): ICardInfoData[] {
        switch (type) {
            case CARD_INFO_ENUM.APP_MARKETING:
                return AppMarketingInfoWithBackground;
            default:
                return []
        }
    }

    getCardWithBulletsData(type: CARD_INFO_ENUM): ICardWithBulletsData[] {
        switch (type) {
            case CARD_INFO_ENUM.AEO_MARKETING:
                return AEO_BULLETS;
            default:
                return []
        }
    }

}